import axios from "axios";
import {apiUrl} from "../../api/common";
import CartEvents from "../../events/CartEvents";
import {Cart, CartItem, CartItemAddon, ConfigurableItem} from "../../types/cart/cart";

export class CartHandler {

    public static getCart() : Promise<Cart> {
        return new Promise<Cart> (function (resolve, reject) {
            axios.get(apiUrl + '/cart' ,{withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static getCartItemNumber() : Promise<number> {
        return new Promise<number> (function (resolve, reject) {
            axios.get(apiUrl + '/cart/count' ,{withCredentials: true}).then((response) => {
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static addItemToCart(newCartItem: any): Promise<CartItem> {
        let cartItem = {
            productId : newCartItem.productId,
            addons: new Array<CartItemAddon>(),
            quantity: newCartItem.quantity,
            price: newCartItem.price,
        }
        return new Promise<any> (function (resolve, reject) {
            axios.post(apiUrl + '/cart', cartItem,{withCredentials: true}).then((response:any) => {
                CartEvents.callCartModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                console.log(err.response);
                reject(err);
            });
        });
    }

    public static addAddonToCartItem(newCartItemConfigurable: ConfigurableItem): Promise<any> {
        return new Promise<any> (function (resolve, reject) {
            axios.post(apiUrl + '/cart/addons', newCartItemConfigurable,{withCredentials: true}).then((response:any) => {
                CartEvents.callCartModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                console.log(err.response);
                reject(err);
            });
        });
    }

    public static deleteProductFromCart(cartItemId: string,): Promise<Cart> {
        return new Promise<Cart> (function (resolve, reject) {
            axios.delete(apiUrl + '/cart/'+cartItemId ,{withCredentials: true}).then((response) => {
                CartEvents.callCartModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }

    public static UpdateCartItem(cartItem: CartItem): Promise<Cart> {
        return new Promise<Cart> (function (resolve, reject) {
            axios.put(apiUrl + '/cart' ,cartItem,{withCredentials: true}).then((response) => {
                CartEvents.callCartModifiedEvents();
                resolve(response.data);
            }).catch((err: any) => {
                reject(err.response);
            });
        });
    }
}
